import Admin from "../Admin";
import React from "react";
import CardAdminIssueCategoryList from "../../../Component/Card/Admin/IssueCategory/CardAdminIssueCategoryList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminIssueCategoryList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminIssueCategoryList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/issueCategory"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Issue Categories" buttons={buttons} />
        );
    }
}
